const identityCardViewAddress = "https://api2.idha.com.br:3004"

export default identityCardViewAddress